import { Directive, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DateUtilsService } from '../common/date-utils.service';
import { DateService } from '../common/date.service';
import { FixDateConverter, FixDateService } from '../common/fixDate.service';
import { parseDateRange } from '../common/date-range-parser';

@Directive({
  selector: '[appFixDateConditionally]'
})
export class FixDateConditionallyDirective implements OnInit {

  @Input() fixDateEnabled: boolean;
  @Input() appFixDateType: string;
  @Input() unknownReplacement: string;

  private converter: FixDateConverter;

  constructor(
    private control: NgControl,
    private dateService: DateService,
    private dateUtils: DateUtilsService,
    private fixDateService: FixDateService
  ) { }

  ngOnInit(): void {
    if (this.fixDateEnabled) {
      const { from, to } = parseDateRange(
        this.appFixDateType,
        this.dateService,
        this.dateUtils
      );

      this.converter = this.fixDateService.getConverter({
        preferredFrom: from,
        preferredTo: to,
        unknownReplacement: this.unknownReplacement,
      });
    }
  }

  @HostListener('blur', ['$event'])
  onTextBlur(evt) {
    if (this.fixDateEnabled) {
      this.onInput(evt.target.value);
    }
  }

  onInput(value: any): void {
    const transformed = this.transformValue(value);
    this.control.control.setValue(transformed);
  }

  transformValue(value: any): any {
    return this.converter.convert(value);
  }
}
